import { SharedModule } from 'src/app/modules/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImmigrationWizardRoutingModule } from './immigration-wizard.routing.module';
import { ImmigrationWizardContainerComponent } from './immigration-wizard-container/immigration-wizard-container.component';
import { TabViewModule } from 'primeng/tabview';
import { LcaDetailsComponent } from './lca-details/lca-details.component';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { MatTableModule } from '@angular/material/table';
import { MenuModule } from 'primeng/menu';
import { MatMenuModule } from '@angular/material/menu';
import { ButtonModule } from 'primeng/button';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { MatDividerModule } from '@angular/material/divider';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CarouselModule } from 'primeng/carousel';
import { ListJobDutiesModule } from 'list-job-duties';
import { WizardHeadComponent } from './wizard-head/wizard-head.component';
import { IndividualDetailsComponent } from './individual-details/individual-details.component';
import { JobDescriptionComponent } from './job-description/job-description.component';
import { LcaSocCodeLibraryModule } from 'lca-soc-code-library';
import { SocCodeComponent } from './soc-code/soc-code.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ReviewAnalyzePetitionDetailsComponent } from './review-analyze-petition-details/review-analyze-petition-details.component';
import { PrintPetitionLibraryModule } from 'print-petition-library';
import { MatTabsModule } from '@angular/material/tabs';
import { JobDescriptionLcaPositionLibraryModule } from 'job-description-lca-position-library';
import { JobDescriptionLcaWorkLibraryModule } from 'job-description-lca-work-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { ToastModule } from 'primeng/toast';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { DateFormatModule } from 'date-format';
import { LastUpdateLibraryModule } from 'last-update-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { UscisContentComponent } from './uscis-content/uscis-content.component';
import { FeeCalculationLibraryModule } from 'fee-calculation-library';
import { ReviewPetitionLibraryModule } from 'review-petition-library';
import { ReviewCommentsLibraryModule } from 'review-comments-library';
import { AccordionModule } from 'primeng/accordion';
//import { BeneficiaryDocumentsEditLibraryModule } from 'beneficiary-documents-edit-library';
import { EditEducationDetailsTabModule } from 'edit-education-details-tab';
import { DocumentChecklistLibraryModule } from 'document-checklist-library';
import { MatBadgeModule } from '@angular/material/badge';
import { BulkDocumentsDownloadModule } from 'bulk-documents-download';
//import { SimpleEducationDetailLibraryModule } from 'simple-education-detail-library';
//import { SimpleImmigrationDetailLibraryModule } from 'simple-immigration-detail-library';
import { SubmitRecieptComponent } from './submit-reciept/submit-reciept.component';
import { SubmitPetitionLibraryModule } from 'submit-petition-library';
import { GetReceiptsLibraryModule } from 'projects/get-receipts-library/src/public-api';
import { GenerateLettersComponent } from './generate-letters/generate-letters.component';
import { CoverLetterLibraryModule } from 'cover-letter-library';
import { SupportLetterLibraryModule } from 'support-letter-library';
import { OrganizeDocumentsLibraryModule } from 'organize-documents-library';
import { PlaceHolderLibraryModule } from 'place-holder-library';
import { LetterTemplateLibraryModule } from 'letter-template-library';
import { DigitalSignatureLibraryModule } from 'digital-signature-library';
import { LetterGenerationLibraryModule } from 'letter-generation-library';
import { GenerateFormsLibraryModule } from 'generate-forms-library';
import { ImmigrationDocumentUploadComponent } from './immigration-document-upload/immigration-document-upload.component';
import { MailingAddressLibraryModule } from 'mailing-address-library';
import { ConsulateAddressLibraryModule } from 'consulate-address-library';
import { LCAModule } from '../lca/lca.module';
import { UpdateWizardComponent } from './update-wizard/update-wizard.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SwithModePopupComponent } from './switch-mode-popup/switch-mode-popup.component';
import { EducationDetailsComponent } from './education-details/education-details.component';
import { EducationDetailsLibraryModule } from 'projects/education-details-library/src/public-api';
import { EmployerEmployeeRelationshipComponent } from './employer-employee-relationship/employer-employee-relationship.component';
//import { SimpleExperienceDetailLibraryModule } from 'projects/simple-experience-detail-library/src/public-api';
import { GenericBeneficiaryWorkExperienceModule } from 'generic-beneficiary-work-experience';
import { ItineraryOfServicesComponent } from './itinerary-of-services/itinerary-of-services.component';
import { ItineraryOfServicesLibraryModule } from 'itinerary-of-services-library';
import { PetitionerDetailsLibraryModule } from 'petitioner-details-library';
import { L1Module } from '../l1-visa/l1.module';
import { ConfirmationService } from 'primeng/api';
import { CreateTemplateLibraryModule } from 'create-template-library';
import { LetterPreviewLibraryModule } from 'letter-preview-library';
import { LetterGenerationEntryLibraryModule } from 'letter-generation-entry-library';
import { PdfViewLibraryModule } from 'pdf-view-library';
import { DocumentChecklistNewLibraryModule } from 'document-checklist-new-library';
import { GenericBeneficiaryPersonalDetailsLibraryModule } from 'generic-beneficiary-personal-details-library';
import { GenericBeneficiaryImmigrationDetailsLibraryModule } from 'generic-beneficiary-immigration-details-library';
import { GenericBeneficiaryEducationModule } from 'generic-beneficiary-education';
import { SendFormsForSignatureComponent } from './send-forms-for-signature/send-forms-for-signature.component';

@NgModule({
  declarations: [
    LcaDetailsComponent,
    ImmigrationWizardContainerComponent,
    WizardHeadComponent,
    IndividualDetailsComponent,
    JobDescriptionComponent,
    ImmigrationDocumentUploadComponent,
    SocCodeComponent,
    ReviewAnalyzePetitionDetailsComponent,
    SendFormsForSignatureComponent,
    UscisContentComponent,
    SubmitRecieptComponent,
    GenerateLettersComponent,
    UpdateWizardComponent,
    SwithModePopupComponent,
    EmployerEmployeeRelationshipComponent,
    EducationDetailsComponent,
    ItineraryOfServicesComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CarouselModule,
    LcaSocCodeLibraryModule,
    CheckboxModule,
    AutoCompleteModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    DialogModule,
    TableModule,
    PaginatorModule,
    ImmigrationWizardRoutingModule,
    TabViewModule,
    ConfirmPopupModule,
    MatTableModule,
    MatMenuModule,
    MenuModule,
    MatButtonModule,
    ButtonModule,
    MatIconModule,
    MatCheckboxModule,
    ConfirmDialogModule,
    MatDividerModule,
    OverlayPanelModule,
    MultiSelectModule,
    CalendarModule,
    MatTooltipModule,
    DropdownModule,
    PdfViewerModule,
    ListJobDutiesModule,
    MatTabsModule,
    JobDescriptionLcaPositionLibraryModule,
    JobDescriptionLcaWorkLibraryModule,
    AccordionModule,
    // EditPersonalDetailsModule,
    EditEducationDetailsTabModule,
    DocumentChecklistLibraryModule,
    PrimengLibraryModule,
    MatBadgeModule,
    FormsModule,
    BulkDocumentsDownloadModule,
    // SimplePersonalDetailLibraryModule,
    // SimpleImmigrationDetailLibraryModule,
    PrintPetitionLibraryModule,
    ToastModule,
    StepStatusUpdateComponentLibraryModule,
    DateFormatModule,
    LastUpdateLibraryModule,
    AssigningTaskLibraryModule,
    MaximizeDialogLibraryModule,
    MatStepperModule,
    FeeCalculationLibraryModule,
    GenerateFormsLibraryModule,
    ReviewPetitionLibraryModule,
    ReviewCommentsLibraryModule,
    SubmitPetitionLibraryModule,
    GetReceiptsLibraryModule,
    CoverLetterLibraryModule,
    SupportLetterLibraryModule,
    OrganizeDocumentsLibraryModule,
    DocumentChecklistNewLibraryModule,
    PlaceHolderLibraryModule,
    LetterTemplateLibraryModule,
    DigitalSignatureLibraryModule,
    LetterGenerationLibraryModule,
    MailingAddressLibraryModule,
    ConsulateAddressLibraryModule,
    ItineraryOfServicesLibraryModule,
    LCAModule,
    EducationDetailsLibraryModule,
    PetitionerDetailsLibraryModule,
    L1Module,
    CreateTemplateLibraryModule,
    LetterPreviewLibraryModule,
    LetterGenerationEntryLibraryModule,
    PdfViewLibraryModule,
    GenericBeneficiaryPersonalDetailsLibraryModule,
    GenericBeneficiaryImmigrationDetailsLibraryModule,
    GenericBeneficiaryWorkExperienceModule,
    GenericBeneficiaryEducationModule
  ],
  exports: [ImmigrationDocumentUploadComponent],
  providers: [DialogService, ConfirmationService, DynamicDialogConfig, DynamicDialogRef],
})
export class ImmigrationWizardModule { }
